import { Account } from '../../auth';
import { RoutineType } from '../../graphql';
import { Workspace } from '../../workspace';
import { RoutineConfig } from './routineConfig';
import { Workflow } from '../../workflow';
import { Group } from '../../group';
import { Role } from '../../account';

export interface WorkspaceRoutine {
  id: string;
  type?: RoutineType;
  name?: string;
  order: number;
  config: RoutineConfig;
  workspace?: Workspace;
  groups?: Group[];
  currentVersion: WorkspaceRoutineVersion;
  createdBy?: Account;
  deactivated?: boolean;
  permittedRoles?: Role[];
  isWorkspaceRoutine?: boolean;
}

export interface RoutineWorkflow extends Workflow {
  createdAt: Date;
  updatedAt: Date;
  uom?: string;
  count?: number;
}

export interface WorkspaceRoutineVersion {
  id: string;
}
